import {fetchWithAuth, makeAppIdConfig} from './../fetch-json.util';

class GuestUserService {
    static fetchSession() {
        return fetchWithAuth(
            AUTH_SESSION_ME_URL,
            makeAppIdConfig()
        ).then((response) => {
            return response.json();
        });
    }

    static upgradeGuestSession(email, cartId) {
        return fetchWithAuth(
            AUTH_SESSION_UPGRADE_GUEST_URL,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email,
                    cartId
                })
            }
        );
    }

    static upgradeSsoSession(code, redirectUri, codeVerifier) {
        return fetchWithAuth(
            AUTH_SESSION_UPGRADE_SSO_URL,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    code,
                    redirectUri,
                    codeVerifier
                })
            }
        );
    }

    static logOff() {
        return fetchWithAuth(
            AUTH_SESSION_LOGOUT_URL,
            {
                method: 'POST'
            }
        );
    }
}

export default GuestUserService;
